require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./button"), require("./link"), require("./svgicon"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./button", "./link", "./svgicon", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./button"), require("./link"), require("./svgicon"), require("./utils")) : factory(root["./button"], root["./link"], root["./svgicon"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__32477__, __WEBPACK_EXTERNAL_MODULE__85717__, __WEBPACK_EXTERNAL_MODULE__56685__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[5922],{

/***/ 65344:
/***/ ((module) => {

var amdi18n={"__root":{"alerts":"Alerts","dismiss":"Dismiss"},"__cs":{"alerts":"Výstrahy","dismiss":"Opustit"},"__da":{"alerts":"Varsler","dismiss":"Afvis"},"__de":{"alerts":"Alerts","dismiss":"Schließen"},"__es":{"alerts":"Alertas","dismiss":"Descartar"},"__fi":{"alerts":"Hälytykset","dismiss":"Ohita"},"__fr":{"alerts":"Alertes","dismiss":"Fermer"},"__hr":{"alerts":"Uzbune","dismiss":"Odbaci"},"__hu":{"alerts":"Riasztások","dismiss":"Elvetés"},"__it":{"alerts":"Avvisi","dismiss":"Rimuovi"},"__ja":{"alerts":"アラート","dismiss":"解放"},"__kk":{"alerts":"Ескертулер","dismiss":"Бас тарту"},"__ko":{"alerts":"경고","dismiss":"닫기"},"__nb":{"alerts":"Varsler","dismiss":"Avvis"},"__nl":{"alerts":"Alerts","dismiss":"Verwijderen"},"__no":{"alerts":"Varsler","dismiss":"Avvis"},"__pl":{"alerts":"Alerty","dismiss":"Zamknij"},"__pt":{"alerts":"Alertas","dismiss":"Indeferir"},"__pt-br":{"alerts":"Alertas","dismiss":"Indeferir"},"__ro":{"alerts":"Alerte","dismiss":"Renunţare"},"__ru":{"alerts":"Оповещения","dismiss":"Отбросить"},"__sl":{"alerts":"Opozorila","dismiss":"Opusti"},"__sv":{"alerts":"Varningar","dismiss":"Avvisa"},"__th":{"alerts":"แจ้งเตือน","dismiss":"ยกเลิก"},"__tr":{"alerts":"Uyarılar","dismiss":"Kapat"},"__zh":{"alerts":"警报","dismiss":"关闭"},"__zh-cn":{"alerts":"警报","dismiss":"关闭"},"__zh-hk":{"alerts":"警示","dismiss":"跳出"},"__zh-mo":{"alerts":"警示","dismiss":"跳出"},"__zh-sg":{"alerts":"警报","dismiss":"关闭"},"__zh-tw":{"alerts":"警示","dismiss":"跳出"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 81496:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports.sampleSimpleAlert = exports.sampleAlertwithTitle = exports.sampleAlertWithEmptyLabelAction = exports.sampleAlertWithEmptyAction = exports.sampleAlertWithActionById = exports.sampleAlertWithAction = exports.alertModel = exports.alertActionModel = void 0;
var _propTypes = _interopRequireDefault(__webpack_require__(580));
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const alertActionModel = exports.alertActionModel = _propTypes.default.shape({
  id: _propTypes.default.string,
  label: _propTypes.default.string.isRequired,
  url: _propTypes.default.string
});
const alertModel = exports.alertModel = _propTypes.default.shape({
  id: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  message: _propTypes.default.string.isRequired,
  action: alertActionModel
}).isRequired;
const sampleSimpleAlert = exports.sampleSimpleAlert = {
  id: '123',
  message: "Check out what's new"
};
const sampleAlertwithTitle = exports.sampleAlertwithTitle = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new"
};
const sampleAlertWithAction = exports.sampleAlertWithAction = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new",
  action: {
    label: 'Go to release notes',
    url: 'http://www.ibm.com'
  }
};
const sampleAlertWithEmptyAction = exports.sampleAlertWithEmptyAction = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new",
  action: {
    label: ''
  }
};
const sampleAlertWithEmptyLabelAction = exports.sampleAlertWithEmptyLabelAction = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new",
  action: {
    label: '',
    id: '111'
  }
};
const sampleAlertWithActionById = exports.sampleAlertWithActionById = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new",
  action: {
    label: 'Go to release notes',
    id: 'openGlobalToast'
  }
};

/***/ }),

/***/ 7554:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _AlertNavigator = _interopRequireDefault(__webpack_require__(17932));
var _AlertContainer = _interopRequireDefault(__webpack_require__(98726));
var _AlertPropTypes = __webpack_require__(81496);
var _PersistentBanner = _interopRequireDefault(__webpack_require__(39653));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const persistentBannerClassName = _PersistentBanner.default.persistentBannerClassName.replace(/"/g, '');
const persistentBannerChildClassName = `${persistentBannerClassName}-child`;
class PersistentBanner extends _react.Component {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "onDismiss", () => {
      const callback = this.props.onDismiss;
      if (callback) {
        const potentialPromise = callback(this.state.currentAlert);
        if (potentialPromise && potentialPromise.then) {
          return potentialPromise.then(() => {
            this.prev();
          });
        }
        this.prev();
      }
      return Promise.resolve();
    });
    (0, _defineProperty2.default)(this, "prev", () => {
      const {
        currentAlert
      } = this.state;
      this.setState({
        currentAlert: Math.max(currentAlert - 1, 0)
      });
    });
    (0, _defineProperty2.default)(this, "next", () => {
      const {
        currentAlert
      } = this.state;
      const alertsLength = this.props.alerts.length;
      this.setState({
        currentAlert: Math.min(currentAlert + 1, alertsLength - 1)
      });
    });
    this.state = {
      currentAlert: 0
    };
  }
  render() {
    const {
      alerts,
      onGoToAction
    } = this.props;
    const {
      currentAlert
    } = this.state;
    return alerts && alerts.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: persistentBannerClassName
    }, /*#__PURE__*/_react.default.createElement(_AlertNavigator.default, {
      currentAlert: currentAlert,
      alertsLength: alerts.length,
      className: persistentBannerChildClassName,
      onPrev: this.prev,
      onNext: this.next
    }), /*#__PURE__*/_react.default.createElement(_AlertContainer.default, {
      alert: alerts[currentAlert],
      className: persistentBannerChildClassName,
      onDismiss: this.onDismiss,
      onGoToAction: onGoToAction
    }));
  }
}
exports["default"] = PersistentBanner;
PersistentBanner.propTypes = {
  /** Alert configuration */
  alerts: _propTypes.default.arrayOf(_AlertPropTypes.alertModel),
  /** Dismiss callback - will be called with the alert index when a alert is dismissed. */
  onDismiss: _propTypes.default.func,
  /** GoToAction callback - will be called with the alert.action.id when the goto action is clicked and no url is specified with the action. */
  onGoToAction: _propTypes.default.func
};

/***/ }),

/***/ 98726:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = AlertContainer;
var _react = _interopRequireDefault(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _AlertMessage = _interopRequireDefault(__webpack_require__(2672));
var _AlertGoToAction = _interopRequireDefault(__webpack_require__(25020));
var _AlertPropTypes = __webpack_require__(81496);
var _AlertContainer = _interopRequireDefault(__webpack_require__(14147));
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const alertContainerClassName = _AlertContainer.default.alertContainerClassName.replace(/"/g, '');
function isEmpty(item) {
  return item === undefined || item === null || item === '';
}
function isActionEmpty(alert) {
  return !alert || !alert.action || isEmpty(alert.action.label) && isEmpty(alert.action.id) && isEmpty(alert.action.url);
}
function AlertContainer(props) {
  const {
    alert,
    className,
    onDismiss,
    onGoToAction
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `${className} ${alertContainerClassName}`
  }, alert && /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    alert: alert,
    onDismiss: onDismiss
  }), !isActionEmpty(alert) && /*#__PURE__*/_react.default.createElement(_AlertGoToAction.default, {
    action: alert.action,
    onGoToAction: onGoToAction
  }));
}
AlertContainer.propTypes = {
  alert: _AlertPropTypes.alertModel,
  className: _propTypes.default.string,
  onDismiss: _propTypes.default.func,
  onGoToAction: _propTypes.default.func
};
AlertContainer.defaultProps = {
  className: ''
};

/***/ }),

/***/ 25020:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = AlertGoToAction;
var _react = _interopRequireDefault(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _button = _interopRequireDefault(__webpack_require__(32477));
var _arrowRight_ = _interopRequireDefault(__webpack_require__(9271));
var _AlertGoToAction = _interopRequireDefault(__webpack_require__(64532));
var _AlertPropTypes = __webpack_require__(81496);
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const alertGoToActionClassName = _AlertGoToAction.default.alertGoToActionClassName.replace(/"/g, '');
function onClick(action, callback) {
  const {
    url
  } = action;
  if (url) {
    window.open(url, '_blank');
  }
  if (callback) {
    callback(action);
  }
}
function AlertGoToAction(props) {
  const {
    action,
    onGoToAction
  } = props;
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    className: alertGoToActionClassName,
    iconRight: _arrowRight_.default.id,
    label: action.label,
    title: action.label,
    onClick: () => onClick(props.action, onGoToAction)
  });
}
AlertGoToAction.propTypes = {
  action: _AlertPropTypes.alertActionModel,
  onGoToAction: _propTypes.default.func
};

/***/ }),

/***/ 2672:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = AlertMessage;
var _react = _interopRequireDefault(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _information_ = _interopRequireDefault(__webpack_require__(21149));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _link = _interopRequireDefault(__webpack_require__(85717));
var _AlertPropTypes = __webpack_require__(81496);
var _AlertMessage = _interopRequireDefault(__webpack_require__(83904));
var _StringResource = _interopRequireDefault(__webpack_require__(86569));
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const alertMessageClassName = _AlertMessage.default.alertMessageClassName.replace(/"/g, '');
const messageContainerClassName = _AlertMessage.default.messageContainerClassName.replace(/"/g, '');
const dismissContainerClassName = _AlertMessage.default.dismissContainerClassName.replace(/"/g, '');
const optionalTitleClassName = _AlertMessage.default.optionalTitleClassName.replace(/"/g, '');
function renderOptionalTitle(title) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    iconId: _information_.default.id
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: optionalTitleClassName
  }, title));
}
function AlertMessage(props) {
  const {
    alert,
    onDismiss
  } = props;
  if (!alert) {
    return false;
  }
  return (
    /*#__PURE__*/
    /* eslint-disable jsx-a11y/anchor-is-valid */
    _react.default.createElement("div", {
      className: alertMessageClassName
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: messageContainerClassName
    }, alert.title && renderOptionalTitle(alert.title), alert.message), /*#__PURE__*/_react.default.createElement("div", {
      className: dismissContainerClassName
    }, /*#__PURE__*/_react.default.createElement(_link.default, {
      onClick: onDismiss
    }, _StringResource.default.get('dismiss'))))
    /* eslint-enable jsx-a11y/anchor-is-valid */
  );
}

AlertMessage.propTypes = {
  alert: _AlertPropTypes.alertModel,
  onDismiss: _propTypes.default.func
};

/***/ }),

/***/ 17932:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _AlertNavigator = _interopRequireDefault(__webpack_require__(16628));
var _AlertNavigatorLabel = _interopRequireDefault(__webpack_require__(7019));
var _AlertNavigatorButtons = _interopRequireDefault(__webpack_require__(74723));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const alertNavigatorClassName = _AlertNavigator.default.alertNavigatorClassName.replace(/"/g, '');
class AlertNavigator extends _react.Component {
  render() {
    const {
      currentAlert,
      alertsLength,
      className,
      onPrev,
      onNext
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `${className} ${alertNavigatorClassName}`
    }, /*#__PURE__*/_react.default.createElement(_AlertNavigatorLabel.default, {
      currentAlert,
      alertsLength
    }), alertsLength > 1 && /*#__PURE__*/_react.default.createElement(_AlertNavigatorButtons.default, {
      currentAlert,
      alertsLength,
      onPrev,
      onNext
    }));
  }
}
exports["default"] = AlertNavigator;
AlertNavigator.propTypes = {
  currentAlert: _propTypes.default.number.isRequired,
  alertsLength: _propTypes.default.number.isRequired,
  className: _propTypes.default.string,
  onPrev: _propTypes.default.func,
  onNext: _propTypes.default.func
};
AlertNavigator.defaultProps = {
  currentAlert: 0,
  alertsLength: 0,
  className: ''
};

/***/ }),

/***/ 74723:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = AlertNavigatorButtons;
var _react = _interopRequireDefault(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _button = _interopRequireDefault(__webpack_require__(32477));
var _arrowLeft_ = _interopRequireDefault(__webpack_require__(70051));
var _arrowRight_ = _interopRequireDefault(__webpack_require__(9271));
var _AlertNavigatorButtons = _interopRequireDefault(__webpack_require__(61150));
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const alertNavigatorButtonsClassName = _AlertNavigatorButtons.default.alertNavigatorButtonsClassName.replace(/"/g, '');
function AlertNavigatorButtons(props) {
  const {
    alertsLength,
    onPrev,
    onNext
  } = props;
  const currentAlert = props.currentAlert + 1;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: alertNavigatorButtonsClassName
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    varient: "icon",
    icon: _arrowLeft_.default.id,
    disabled: currentAlert === 1,
    onClick: onPrev
  }), /*#__PURE__*/_react.default.createElement(_button.default, {
    varient: "icon",
    icon: _arrowRight_.default.id,
    disabled: currentAlert === alertsLength,
    onClick: onNext
  }));
}
AlertNavigatorButtons.propTypes = {
  currentAlert: _propTypes.default.number.isRequired,
  alertsLength: _propTypes.default.number.isRequired,
  onPrev: _propTypes.default.func,
  onNext: _propTypes.default.func
};
AlertNavigatorButtons.defaultProps = {
  currentAlert: 0,
  alertsLength: 0
};

/***/ }),

/***/ 7019:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = AlertNavigatorLabel;
var _react = _interopRequireDefault(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _AlertNavigatorLabel = _interopRequireDefault(__webpack_require__(1360));
var _StringResource = _interopRequireDefault(__webpack_require__(86569));
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const alertNavigatorLabelClassName = _AlertNavigatorLabel.default.alertNavigatorLabelClassName.replace(/"/g, '');
function formatNumAlerts(currentAlert, alertsLength) {
  return `${currentAlert + 1}/${alertsLength}`;
}
function AlertNavigatorLabel(props) {
  const {
    currentAlert,
    alertsLength
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: alertNavigatorLabelClassName
  }, formatNumAlerts(currentAlert, alertsLength), " ", _StringResource.default.get('alerts'));
}
AlertNavigatorLabel.propTypes = {
  currentAlert: _propTypes.default.number.isRequired,
  alertsLength: _propTypes.default.number.isRequired
};
AlertNavigatorLabel.defaultProps = {
  currentAlert: 0,
  alertsLength: 0
};

/***/ }),

/***/ 62903:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _PersistentBanner = _interopRequireDefault(__webpack_require__(7554));
exports["default"] = _PersistentBanner.default;
exports.PersistentBanner = _PersistentBanner.default;
var _AlertContainer = _interopRequireDefault(__webpack_require__(98726));
exports.AlertContainer = _AlertContainer.default;
var _AlertNavigator = _interopRequireDefault(__webpack_require__(17932));
exports.AlertNavigator = _AlertNavigator.default;
var _AlertNavigatorLabel = _interopRequireDefault(__webpack_require__(7019));
exports.AlertNavigatorLabel = _AlertNavigatorLabel.default;
var _AlertNavigatorButtons = _interopRequireDefault(__webpack_require__(74723));
exports.AlertNavigatorButtons = _AlertNavigatorButtons.default;
var _AlertMessage = _interopRequireDefault(__webpack_require__(2672));
exports.AlertMessage = _AlertMessage.default;
var _AlertGoToAction = _interopRequireDefault(__webpack_require__(25020));
exports.AlertGoToAction = _AlertGoToAction.default;

/***/ }),

/***/ 86569:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _utils = __webpack_require__(78815);
var _PersistentBannerResources = _interopRequireDefault(__webpack_require__(65344));
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = exports["default"] = new _utils.StringResource(_PersistentBannerResources.default);

/***/ }),

/***/ 25894:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-persistent-banner{display:flex;align-items:center;height:40px;color:#fff;font-size:.875rem}.ba-persistent-banner .ba-persistent-banner-child{display:flex;align-items:center;padding-left:16px;height:100%}", ""]);

// exports
exports.locals = {
	"persistentBannerClassName": "\"ba-persistent-banner\"",
	"persistentBannerChildClassName": "\"ba-persistent-banner-child\""
};

/***/ }),

/***/ 3736:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-alert-container{background-color:#2d74da;flex-grow:1}", ""]);

// exports
exports.locals = {
	"alertContainerClassName": "\"ba-alert-container\""
};

/***/ }),

/***/ 10906:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-alert-goto-action.ba-common-button.is-variant_solid{background-color:#000;font-weight:400;padding:0 16px;min-width:fit-content}.ba-alert-goto-action.ba-common-button.is-variant_solid .ba-common-button__label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:106px;max-width:126px}.ba-alert-goto-action.ba-common-button.is-variant_solid:hover:not(.is-disabled):not(.is-tap){background-color:#595859}.ba-alert-goto-action span.ba-common-button__icon.is-right{padding-left:16px}", ""]);

// exports
exports.locals = {
	"alertGoToActionClassName": "\"ba-alert-goto-action\""
};

/***/ }),

/***/ 75290:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-alert-message{display:flex;align-items:center;flex-grow:1;padding-right:16px}.ba-alert-message .ba-message-container{display:flex;align-items:center;flex-grow:1}.ba-alert-message .ba-message-container .ba-optional-title{font-weight:600;padding:0 16px 0 8px}.ba-alert-message .ba-message-container .ba-common-svgIcon{min-width:16px}.ba-alert-message .ba-dismiss-container .ba-common-link{color:#fff}.ba-alert-message .ba-dismiss-container .ba-common-link:hover{color:#eaeaea}", ""]);

// exports
exports.locals = {
	"toolTipIconClassName": "\"ba-common-svgIcon\"",
	"alertMessageClassName": "\"ba-alert-message\"",
	"messageContainerClassName": "\"ba-message-container\"",
	"dismissContainerClassName": "\"ba-dismiss-container\"",
	"optionalTitleClassName": "\"ba-optional-title\""
};

/***/ }),

/***/ 1551:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-persistent-banner{display:flex;align-items:center;height:40px;color:#fff;font-size:.875rem}.ba-persistent-banner .ba-persistent-banner-child{display:flex;align-items:center;padding-left:16px;height:100%}.ba-alert-navigator{background-color:#000}", ""]);

// exports
exports.locals = {
	"persistentBannerClassName": "\"ba-persistent-banner\"",
	"persistentBannerChildClassName": "\"ba-persistent-banner-child\"",
	"alertNavigatorClassName": "\"ba-alert-navigator\""
};

/***/ }),

/***/ 66370:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-alert-navigator-buttons{min-width:80px}.ba-alert-navigator-buttons .ba-common-button.is-variant_solid{min-width:40px;width:40px;padding:0;background-color:#343334}.ba-alert-navigator-buttons .ba-common-button.is-variant_solid:hover:not(.is-disabled):not(.is-tap){background-color:#595859}.ba-alert-navigator-buttons .ba-common-button.is-disabled{opacity:1;background-color:#595859}.ba-alert-navigator-buttons .ba-common-button.is-disabled svg{opacity:.5}", ""]);

// exports
exports.locals = {
	"alertNavigatorButtonsClassName": "\"ba-alert-navigator-buttons\""
};

/***/ }),

/***/ 8850:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-alert-navigator-label{padding-right:16px}", ""]);

// exports
exports.locals = {
	"alertNavigatorLabelClassName": "\"ba-alert-navigator-label\""
};

/***/ }),

/***/ 39653:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25894);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_PersistentBanner_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 14147:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3736);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertContainer_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 64532:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10906);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertGoToAction_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 83904:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75290);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertMessage_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 16628:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1551);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigator_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 61150:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66370);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorButtons_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 1360:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8850);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_AlertNavigatorLabel_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 70051:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/arrow--left_16");

/***/ }),

/***/ 9271:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/arrow--right_16");

/***/ }),

/***/ 21149:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/information_16");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 32477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32477__;

/***/ }),

/***/ 85717:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__85717__;

/***/ }),

/***/ 56685:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56685__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(62903));
/******/ return __webpack_exports__;
/******/ }
]);
});